export default __webpack_public_path__ + "static/sun-463a7036c412a0bb289640fff4d4e329.png";